import React, { ReactNode } from 'react'

interface AdminInputTooltipProps {
  label: string
  tooltipText: string | ReactNode
  isTooltipOpen: boolean
  onTooltipMouseEnter: () => void
  onTooltipMouseLeave: () => void
  children: ReactNode
}

const AdminInputTooltip: React.FC<AdminInputTooltipProps> = ({
  label,
  tooltipText,
  isTooltipOpen,
  onTooltipMouseEnter,
  onTooltipMouseLeave,
  children,
}) => {
  return (
    <div>
      <div className="flex items-center gap-4px mb-4px relative">
        <label className="text-style-labelS text-textColorText2">{label}</label>
        <div
          className="relative"
          onMouseEnter={onTooltipMouseEnter}
          onMouseLeave={onTooltipMouseLeave}
        >
          <span
            className={`
              cursor-help
              text-textColorText2
              hover:text-brown-80%-main
              w-16px
              h-16px
              flex
              items-center
              justify-center
              rounded-full
              border
              border-textColorText2
              hover:border-brandPrimary
              text-12px
              font-bold
              transition-colors
            `}
          >
            ?
          </span>
          {isTooltipOpen && (
            <div
              className={`
                absolute
                right-0
                top-full
                mt-4px
                z-[100]
                w-[280px]
                p-12px
                bg-textColorText1
                text-white
                text-style-captionM
                rounded-8px
                shadow-lg
                whitespace-normal
              `}
              style={{ pointerEvents: 'none' }}
            >
              {tooltipText}
            </div>
          )}
        </div>
      </div>
      {children}
    </div>
  )
}

export default AdminInputTooltip
